export function resolveMyClientsProductAccess({ isNFSeStandaloneEnabled, hasBillingManagementActive, hasNFSeProductActive, }) {
    if (!isNFSeStandaloneEnabled)
        return hasBillingManagementActive;
    return hasBillingManagementActive || hasNFSeProductActive;
}
